const COMPLAINT_FORM = "#complaint_form";

class Complaint {
    constructor() {
        this.$form = null;
    }

    getForm() {
        if (!this.$form || !this.$form.length) {
            this.$form = $(COMPLAINT_FORM);
        }
        return this.$form;
    }

    success(data) {
        this.getForm()[0].reset();
        $("#flash").html('<div class="alert alert-success">'+data['message']+'</div>');
    }

    error() {
        $("#flash").html('<div class="alert alert-danger">Problème lors de l\'envoi du formulaire</div>');
    }

    init() {
    }    

    isPresent(){
        return this.getForm().length;
    }
}

export default new Complaint();